export default __webpack_public_path__ + "static/media/2032.55fcfd2a.png";